import script from "./Boxs.vue?vue&type=script&setup=true&lang=js"
export * from "./Boxs.vue?vue&type=script&setup=true&lang=js"

import "./Boxs.vue?vue&type=style&index=0&id=c75834b8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c75834b8"]])

export default __exports__